import React from "react";
import { IoMdArrowRoundBack } from "react-icons/io";

const RoomGallery = ({ show, handleOpenGallery, onHide, images }) => {
  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            zIndex: 999,
            width: "100%",
            background: "rgb(255, 255, 255)",
            height: "100vh",
          }}
        >
          <div className="room_gallerY_inner">
            <div className="ht_fl_ht_acntr">
              <div onClick={onHide} style={{ marginRight: "10px" }}>
                <IoMdArrowRoundBack size={23} />
              </div>
              <div style={{ width: "80%" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }}>
                  Photos &amp; Videos
                </div>
              </div>
            </div>
            <div style={{ overflow: "scroll", margin: "25px 0" }}>
              <div style={{ height: "100vh", overflowY: "scroll" }}>
                <div
                  _ngcontent-ng-c611272059=""
                  className="mnglryhtap"
                  style={{ paddingBottom: 130 }}
                >
                  {images.map((item, idx) => (
                    <div
                      key={item + idx}
                      style={{ width: "48%", marginBottom: "8px" }}
                    >
                      <img
                        _ngcontent-ng-c611272059=""
                        alt="Hotel"
                        className="room_gallery_images_mobile"
                        src={item}
                        loading={idx < 4 ? "eager" : "lazy"}
                        decoding="async"
                        fetchpriority={idx === 0 ? "high" : undefined}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RoomGallery;
